import { useGlobal } from '@ur-solutions/react-hooks'
import type { Overrides } from '.'
import { useCallback } from 'react'

export function useBreadcrumbs() {
  const [overrides, setOverrides] = useGlobal('breadcrumbs.overrides')
  const [inserts, setInserts] = useGlobal('breadcrumbs.inserts')
  const [excludes, setExcludes] = useGlobal('breadcrumbs.excludes')

  const setOverride = useCallback(
    (key: string, value: string | null) => {
      setOverrides({
        ...overrides,
        [key]: value,
      })
    },
    [overrides, setOverrides]
  )

  const deleteOverrides = useCallback(
    (...keys: string[]) => {
      const includeKeys = Object.keys(overrides).filter(
        key => !keys.includes(key)
      )
      const filteredOverrides = includeKeys.reduce<Overrides>((acc, key) => {
        return {
          ...acc,
          [key]: overrides[key] ?? null,
        }
      }, {})
      setOverrides(filteredOverrides)
    },
    [overrides, setOverrides]
  )

  return {
    overrides,
    setOverride,
    setOverrides,
    deleteOverrides,

    inserts,
    setInserts,

    excludes,
    setExcludes,
  }
}
